// @flow
import * as React from 'react';
import RadioButtons from 'components/RadioButtons';
import Field from './Field';

const RadioButtonsField = ({
  name,
  label,
  description,
  buttons,
  large,
  columns,
  canDeselect,
  ...props
}: {
  name: string,
  label?: React.Node,
  description?: React.Node,
  buttons: Array<{ label: React.Node, value: string | boolean | number }>,
  large?: boolean,
  columns?: 1 | 2,
  canDeselect?: boolean,
  onUpdateValue?: mixed => void
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      const update = v => {
        updateValue(v);
        if (props.onUpdateValue) {
          props.onUpdateValue(v);
        }
      };
      return (
        <RadioButtons
          id={id}
          name={name}
          value={value}
          buttons={buttons}
          large={large}
          hasError={hasError}
          onChange={update}
          canDeselect={canDeselect}
          data-qa-id={qaId}
          columns={columns}
          {...props}
        />
      );
    }}
  />
);

export default RadioButtonsField;
